import { useState } from "react";
import BookAction from "./BookAction.ts";
import ResponseData from "../action/ResponseData.ts";
import Book from "./Book.ts";
function useBookState() {
    const [list, setList] = useState<Array<Book> | null>(null);
    const [error, setError] = useState(null);
    const [updated_at, setUpdatedAt] = useState<Date | null>(null);

    const loadHandler = (data: unknown) => {
        const responseData = data as ResponseData;
        if (responseData.data) {
            // responseData.dataがPromiseの場合は.thenを使用
            if (responseData.data.then && typeof responseData.data.then === "function") {
                responseData.data.then((result: any) => {
                    const books = result.books.map((bookData: any) => {
                        return new Book(
                            bookData.id,
                            bookData.payments[0].book_id,
                            bookData.accommodation_id,
                            new Date(bookData.start_date),
                            bookData.name,
                            bookData.person_number,
                            bookData.price,
                            new Date(bookData.created_at),
                            bookData.payment_limit_date ? new Date(bookData.payment_limit_date) : null,
                            bookData.update_at ? new Date(bookData.update_at) : null
                        );
                    });
                    setList(books);
                    setUpdatedAt(new Date());
                });
            } else {
                // responseData.dataが既に解決済みオブジェクトの場合
                const result = responseData.data;
                const books = result.books.map((bookData: any) => {
                    return new Book(
                        bookData.id,
                        bookData.payments[0].book_id,
                        bookData.accommodation_id,
                        new Date(bookData.start_date),
                        bookData.name,
                        bookData.person_number,
                        bookData.price,
                        new Date(bookData.created_at),
                        bookData.payment_limit_date ? new Date(bookData.payment_limit_date) : null,
                        bookData.update_at ? new Date(bookData.update_at) : null
                    );
                });
                setList(books);
                setUpdatedAt(new Date());
            }
        }
    };
    const errorHandler = (error: unknown) => {
        const responseError = error as ResponseData;
        setError(responseError.error);
    };

    const getUpPaidList = (token: string) => {
        BookAction.getUnPaidList(token, loadHandler, errorHandler);
    };
    const getPaidAndDeletedList = (token: string) => {
        BookAction.getPaidAndDeletedList(token, loadHandler, errorHandler);
    };
    const getNoPlanList = (token: string) => {
        BookAction.getNoPlanList(token, loadHandler, errorHandler);
    };

    return { price_error: error, book_list_updated_at: updated_at, book_list: list, getUpPaidList, getPaidAndDeletedList, getNoPlanList };
}

export default useBookState;
